import { Component, Inject } from '@angular/core';

import { HsgModalDefault, HsgModalDefaultData, HSG_MODAL_DATA, HsgModalRef } from '@hhsg/hsg-asc';
import * as moment from 'moment';

import { MissingBlock } from 'src/shared/models/missing-block.model';
import { ShiftBlockService } from 'src/shared/services/shift-block.service';
import { Constants } from 'src/shared/utilities/constants.util';

export interface MissingBlocksData extends HsgModalDefaultData {
    missingBlocks?: MissingBlock[];
};

@Component({
    selector: 'smt-missing-blocks-modal',
    templateUrl: './missing-blocks-modal.component.html',
    styleUrls: ['./missing-blocks-modal.component.scss']
})
export class MissingBlocksModalComponent extends HsgModalDefault {
	constructor(
        private shiftBlockService: ShiftBlockService,
		public modalRef: HsgModalRef<HsgModalDefault>,
        @Inject(HSG_MODAL_DATA) public data: any) { 
        super(modalRef, data); 
    }
  
    format(missingBlock: MissingBlock) : string {
        return this.shiftBlockService.formatShiftTime(missingBlock.shiftBlock, missingBlock.workflowTimeFacility);
    }

    queryParams(missingBlock: MissingBlock) {
        return {
            date: moment(missingBlock.workflowTimeFacility).format(Constants.FacilityTimeFormat),
            shiftBlockId: missingBlock.shiftBlockId,
            costCenterId: missingBlock.costCenterId
        };
    }

    routerLink() {
        return ['/workflow/planner/'];
    }
}
